/** Redirige vers Stripe Checkout (abonnement mensuel ou annuel). */
export async function startSubscriptionCheckout(api, { plan, resumeDossierId = "", resumeNegId = "" }) {
  const returnPath = `${window.location.pathname}${window.location.search || ""}`;
  const res = await api.post("/subscriptions/checkout", {
    plan,
    resume_dossier_id: resumeDossierId ? String(resumeDossierId) : "",
    resume_negotiation_id: resumeNegId ? String(resumeNegId) : "",
    return_path: returnPath,
  });
  const url = res?.data?.url;
  if (!url) throw new Error("Checkout Stripe indisponible");
  window.location.assign(String(url));
}
